<li class="card-recall-item" *ngIf="!warrantyCheck">
  <div class="content">
    <div *ngIf="upperLabel" class="gb-label gb-color-grey-mid-dark">
      <p class="mb-1">{{upperLabel | translate}}</p>
    </div>
    <ng-container *ngIf="mainLabel !== ''; else noResultsLabel">
      <div class="gb-body1">
        <p class="mb-1">{{mainLabel}}</p>
      </div>
    </ng-container>
    <ng-template #noResultsLabel>
      <div [ngSwitch]="checkCompleteIncomplete" class="gb-body1">
        <p class="mb-1" *ngSwitchCase="'complete'">{{'recallCenter_empty_completeList' | translate}}</p>
        <p class="mb-1" *ngSwitchCase="'incomplete'">{{'recallCenter_empty_incompleteList' | translate}}</p>
        <p class="mb-1" *ngSwitchCase="'Expired'">{{'recallCenter_empty_expiredWarranties' | translate}}</p>
        <p class="mb-1" *ngSwitchCase="'Active'">{{'recallCenter_empty_activeWarranties' | translate}}</p>
        <p class="mb-1" *ngSwitchDefault> {{'recallCenter_unknown_status' | translate}}</p>
      </div>
    </ng-template>

    <div *ngIf="lowerLabel" class="gb-label gb-color-grey-mid-dark">
      <p class="mb-0">{{lowerLabel}}</p>
    </div>
  </div>
  <div class="action">
    <div class="gb-body2">
      <a class="no-href" tabindex="0" (keyup.enter)="openModal(recallTemplate)" (click)="openModal(recallTemplate)" *ngIf="link" [translate]="'recallCenter_viewButton'"></a>
    </div>
  </div>
  <ng-template #recallTemplate>
    <div class="modal-header-cit2">
      <div class="dismiss" aria-label="Close">
        <button href="#" class="no-href" class="gb-icon-button" (click)="modalRef.hide()">
          <span aria-hidden="true" class="icon-ui-close"></span>
        </button>
      </div>
    </div>
    <div class="modal-body-cit2">
      <div class="mb-10">
        <div *ngIf="upperLabel" class="gb-label gb-color-grey-mid-dark">
          <p class="mb-1">{{upperLabel | translate}}</p>
        </div>
        <div *ngIf="mainLabel" class="gb-body1">
          <p class="mb-1">{{mainLabel}}</p>
        </div>
        <div *ngIf="lowerLabel" class="gb-label gb-color-grey-mid-dark">
          <p class="mb-0">{{lowerLabel}}</p>
        </div>
      </div>
      <ng-content select="[recalls]"></ng-content>
      <!--search-results-webu html displayed here-->
    </div>
    <div class="modal-footer-cit2 recall">
      <div class="d-flex">
        <div class="cta">
          <button class="no-href" class="gb-primary-button" (click)="modalRef.hide()"
            [translate]="'recallCenter_modalButton_done'"></button>
        </div>
      </div>
    </div>
  </ng-template>
</li>

<li class="card-recall-item" *ngIf="warrantyCheck">
  <div class="content">
    <div *ngIf="mainLabel" class="gb-body1">
      <p class="mb-1">{{mainLabel}}</p>
    </div>
    <div *ngIf="lowerLabel" class="gb-label gb-color-grey-mid-dark">
      <p class="mb-0">{{lowerLabel}}</p>
    </div>
    <ng-template #warrantyTemplate>
      <div class="modal-header-cit2">
        <div class="dismiss" aria-label="Close">
          <button href="#" class="no-href" class="gb-icon-button" (click)="modalRef.hide()">
            <span aria-hidden="true" class="icon-ui-close"></span>
          </button>
        </div>
      </div>
      <div class="modal-body-cit2">
        <div class="mb-10">
          <div *ngIf="mainModalLabel" class="gb-body1">
            <p class="mb-1">{{mainModalLabel}}</p>
          </div>
          <ng-content select="[warranties]"></ng-content>
        </div>
      </div>
      <div class="modal-footer-cit2 recall">
        <div class="d-flex">
          <div class="cta">
            <a class="no-href" class="gb-primary-button" (click)="modalRef.hide()"
              [translate]="'recallCenter_modalButton_done'"></a>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  <div class="action">
    <div class="gb-body2">
      <a class="no-href" tabindex="0" (keyup.enter)="openModal(warrantyTemplate)" (click)="openModal(warrantyTemplate)"
        *ngIf="link" [translate]="'recallCenter_viewButton'"></a>
    </div>
  </div>
</li>
